import { useState } from 'react';
import * as Yup from 'yup';

import { useLazyGetFilterOptionsQuery } from '../../../../../../services/contacts';

export const useSignupJobFunctionFilter = ({ sharedList, setFilters }) => {
  const [getFilterOptions] = useLazyGetFilterOptionsQuery();
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const formSchema = Yup.object().shape({
    signupJobFunctions: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSearchChange = async (currentValue) => {
    try {
      const data = await getFilterOptions({
        facet: 'signup_job_functions',
        query: currentValue,
        sharedList,
        orderBy: 'alpha',
      }).unwrap();

      return data;
    } catch (error) {
      return [];
    }
  };

  const onSubmit = ({ signupJobFunctions }) => {
    setFilters({ signupJobFunctions });
  };

  const onMenuOpen = () => {
    setIsLoading(true);
    onSearchChange('').then((data) => {
      setDefaultOptions(data);
      setIsLoading(false);
    });
  };

  return {
    formSchema,
    defaultOptions,
    isLoading,
    onMenuOpen,
    onSearchChange,
    onSubmit,
  };
};
